// extracted by mini-css-extract-plugin
export default {"addressSection":"LX-z","disabled":"MX-z","sectionButtons":"NX-z","logo":"OX-z"};